<template>
  <q-layout>
    <div class="q-pa-md justify-center">
        <q-card class="my-card justify-center" flat>
        <q-card-section>
          <h1 class="text-h6">Sign In</h1>
          <h2 class="text-subtitle1">Don't have an account yet? <br /> <router-link to="/user/signup" class="normal-link" style="cursor: pointer">Create one here</router-link></h2>
        </q-card-section>
        <q-card-section v-if="!loadingSubmitted">
          <q-form
            @submit="handleSubmit"
            class="q-gutter-md"
          >
            <q-input
              outlined
              square
              color="secondary"
              type="email"
              required
              v-model="email"
              label="E-mail*"
              hint="address@host.com"
              lazy-rules
              :rules="[ val => val && val.length > 0 || 'Please type something']"
            />

            <q-input
              outlined
              square
              color="secondary"
              type="password"
              :required="action=='signIn'"
              v-model="password"
              minlength="6"
              v-show="action == 'signIn'"
              label="Password*"
              lazy-rules
            />
            <div class="col-12 col-md-4">
              <q-btn @click="handleForgotLink" flat unelevated class="forgot" style="cursor: pointer" color="secondary" :label="(action=='signIn') ? 'Forgot you password?' : 'Login instead'" />
            </div>
            <div class="col-12 col-md-4">
              <q-btn label="Sign In" class="full-width square" unelevated v-if="action == 'signIn'" type="submit" color="secondary"/>
              <q-btn v-if="action == 'forgotPassword'" class="full-width square" unelevated label="Reset password" type="submit" color="secondary" />
            </div>
            <q-banner v-if="error" dense rounded class="text-white bg-red">
              {{error}}
              <template v-slot:action>
                <q-btn flat color="white" @click="error = null" label="Dismiss" />
              </template>
            </q-banner>
            <q-banner v-if="message" dense rounded class="text-white bg-green">
              {{message}}
              <template v-slot:action>
                <q-btn flat color="white" @click="message = null" label="Dismiss" />
              </template>
            </q-banner>
          </q-form>
        </q-card-section>
        <q-card-section v-else>
          <Spinner/>
        </q-card-section>
      </q-card>
    </div>
  </q-layout>
</template>

<script>
import {inject, ref} from "vue";
import router from "@/router";
import Spinner from "@/components/Spinner";
import {useRoute} from "vue-router";
import {useStore} from "vuex";

export default {
  name: "User_SignIn",
  components: {Spinner},
  setup(props, context){
    //refs
    const route = useRoute()
    const email = ref(route.params.email)
    const password = ref('')
    const loadingSubmitted = ref(false)
    const error = ref('')
    const message = ref('')
    const axios = inject('axios')
    const store = useStore()
    
    const action = ref('signIn') //or forgotPassword

    const handleSubmit = async () => {
      loadingSubmitted.value = true
      if (action.value == 'signIn') {
        axios.post(`${process.env.VUE_APP_URL}/login`, 
        {
          email: email.value,
          password: password.value
        })
        .then(async (resp)=>{
          await store.commit('setUser', resp.data)
          
          await store.commit('setAnonymous', null)

          router.push({name: 'Home'})
        })
        .catch((err) => {
          if (err.response) {
            // Request made and server responded
            error.value = err.response.data.detail ?? err.response.data.message
          } else {
            // Something happened in setting up the request that triggered an Error
            error.value = err.message
          }
        })
        .finally(() => loadingSubmitted.value = false)
      }
      
      
      if (action.value == 'forgotPassword') {
        axios.post(`${process.env.VUE_APP_URL}/resetPassword`, 
        {
          email: email.value
        })
        .then((resp)=>{
          message.value = 'E-mail sent. Check your email and click on the link to reset your password.'
        })
        .catch((err) => {
          error.value = 'An error ocurred when resetting password. Wait a few moments and try again.'
        })
        .finally(() => loadingSubmitted.value = false)
      }
    }
    
    const handleForgotLink = () => {
      action.value = action.value == 'forgotPassword' ? 'signIn' : 'forgotPassword'
    }

    store.dispatch('verifyLogged')
    .then(resp => {
      if (!store.getters.isAnonymous) router.push({name: 'Home'})
    })
    .catch(error => {
    })
    
    return {email, password, handleSubmit, error, loadingSubmitted, handleForgotLink, action, message}
  }
}
</script>

<style scoped>

</style>